import axios from 'axios';
export var Service;
(function (Service) {
    Service["Core"] = "core";
    Service["Elastic"] = "elastic";
    Service["Stations"] = "stations";
})(Service || (Service = {}));
export const serviceId = (config, service) => {
    return {
        [Service.Core]: config.AWS_CORE_SERVICE_ID,
        [Service.Elastic]: config.AWS_ELASTIC_SERVICE_ID,
        [Service.Stations]: config.AWS_STATIONS_SERVICE_ID
    }[service];
};
export const getEndpoint = async (config, service, endpoint, params) => {
    try {
        const url = `https://${serviceId(config, service)}.execute-api.us-east-1.amazonaws.com/${config.ENV}/${endpoint}`;
        const res = await axios.get(url, params);
        return res.data;
    }
    catch (error) {
        console.log('AWS error (getEndpoint)', error?.response?.status, error?.response?.data);
        return undefined;
    }
};
export const postEndpoint = async (config, service, endpoint, data) => {
    try {
        const url = `https://${serviceId(config, service)}.execute-api.us-east-1.amazonaws.com/${config.ENV}/${endpoint}`;
        const res = await axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return res.data;
    }
    catch (error) {
        console.log('AWS error (postEndpoint)', error?.response?.status, error?.response?.data);
        return undefined;
    }
};
//# sourceMappingURL=aws.js.map